module.exports = "pegasus/assets/themelp1/large/52.png";